<template>
    <div>
        <div>
            <router-link class="btn btn btn-light" :to="{ name: 'ContactList' }">{{$t('contacts.show.back')}}
            </router-link>
            <button class="btn btn btn-danger" v-b-modal.removeConfirmationModal>{{$t('contacts.show.remove')}}
            </button>
        </div>
        <div class="d-flex align-items-end">
            <h2 class="flex-grow-1">
                {{$t('contacts.show.title', [contactAlias])}}
                <small class="text-muted">
                    <span v-if="totalItems !== stats.total">{{totalItems}}/</span>{{stats.total}}
                </small>
            </h2>
            <b-btn v-b-toggle.filters variant="secondary">
                {{$t('userAnswers.stats.filters')}}
                <font-awesome-icon icon="chevron-down"/>
            </b-btn>
        </div>
        <b-collapse id="filters" @shown="showFilters">
            <stats
                    ref="stats"
                    :base-answers-url="'/contact_user_answers/' + decodeURIComponent(this.$route.params.id)"
                    :base-stats-url="'/contact_user_answer_stats/'+ decodeURIComponent(this.$route.params.id)"
                    store-method="contact/show/getItems"
                    :stats="stats"
                    :contact-id="decodeURIComponent(this.$route.params.id)"/>
        </b-collapse>
        <div class="row mt-3" v-if="items.length">
            <UserAnswerCard v-for="answer in items"
                            :item="answer"
                            :key="answer.id"
                            :owned="false"
            >
            </UserAnswerCard>
        </div>
        <pagination v-bind:view="view" v-bind:getPage="getPage"></pagination>
        <b-modal id="removeConfirmationModal" ref="removeConfirmationModal" :title="$t('contacts.removeModal.title')"
                 @ok="removeContact()"
                 :ok-title="$t('global.modal.ok')" :cancel-title="$t('global.modal.cancel')">
            <i18n path="contacts.removeModal.message">
                <b>{{ contactAliasId }}</b>
            </i18n>
        </b-modal>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Pagination from '../app/Pagination';
import Stats from '../app/Filters';
import UserAnswerCard from '../userAnswer/Card';

export default {
    components: {UserAnswerCard, Pagination, Stats},
    computed: mapGetters({
        items: 'contact/show/items',
        loading: 'loading/loading/loading',
        view: 'contact/show/view',
        contactAlias: 'contact/show/contactAlias',
        contactId: 'contact/show/contactId',
        contactAliasId: 'contact/show/contactAliasId',
        stats: 'contact/show/stats',
        totalItems: 'contact/show/totalItems',
    }),
    methods: {
        ...mapActions({
            getPage: 'contact/show/getItems',
        }),
        removeContact: function () {
            this.$store
                .dispatch('contact/pair/remove', this.$route.params.id)
                .then(() => {
                    this.$router.push({name: 'ContactList'});
                });
        },
        showFilters() {
            this.$refs.stats.refresh();
        },
    },
    created() {
        this.$store.dispatch('contact/show/getContactInfo', this.$route.params.id);
    },
};
</script>



// WEBPACK FOOTER //
// src/components/contact/Show.vue